import { render } from "./LangSelect.vue?vue&type=template&id=3c9e7306&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=3c9e7306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9e7306"]])

export default __exports__